import { PlanTypes } from "../user/store/types";

/**
 * ExportType
 * Represents the different types of allowed exports
 */
export type ExportType = "csv" | "excel";
export enum ExportTypes {
    csv = "csv",
    excel = "excel",
}

/**
 * ExportTableName
 * Represents the different tables that can be exported
 */
export enum ExportTableNames {
    platforms_v4 = "platforms_v4",
    protocols_v4 = "protocols_v4", // NOTE - this should be deprecated
    networks_v4 = "networks_v4",
    assets_v4 = "assets_v4",
    tokens_v4 = "tokens_v4",
    managers_v4 = "managers_v4",
    issuers_v4 = "issuers_v4",
    service_providers_v4 = "service_providers_v4",
    asset_classes_v4 = "asset_classes_v4",
    transactions_v4 = "transactions_v4",
    measures_v4 = "measures_v4",
    reference_data_v4 = "reference_data_v4",
    token_timeseries_v4 = "token_timeseries_v4",
    token_aggregates_v4 = "token_aggregates_v4",
    asset_timeseries_v4 = "asset_timeseries_v4",
    asset_aggregates_v4 = "asset_aggregates_v4",
}
export type ExportTableName = `${ExportTableNames}`;

/**
 * DownloadEvent
 * Represents a record of a user downloading data from the platform
 */
export interface DownloadEvent {
    id: string;
    organizationID: string;
    userID: string;
    downloadType: ExportType;
    downloadTable: ExportTableName;
    downloadFilename: string | null;
    query: string;
    createdAt: Date;
}

/**
 * OrganizationDownloadUsage
 * Represents the rolling download usage for an organization
 * Counts are based on rolling windows: 1 day, 7 days, 30 days
 */
export interface OrganizationDownloadUsage {
    plan_type: PlanTypes;
    limit_exceeded: boolean;
    rolling_1d_count: number;
    rolling_1d_limit: number;
    rolling_7d_count: number;
    rolling_7d_limit: number;
    rolling_30d_count: number;
    rolling_30d_limit: number;
}

// NOTE - we might need this later for something...
// const mapExportTypeToContentType: { [key in ExportTypes]: string } = {
//     [ExportTypes.csv]: "text/csv",
//     [ExportTypes.excel]:
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // TODO - add correct mime type here
//   };
